<template>
  <c-button
    id="btn-submit"
    use-custom-button="primary"
    @click.prevent="onSubmit"
  >
    {{ text }}
  </c-button>
</template>

<script>
import emitter from 'tiny-emitter/instance'
import CButton from '@atoms/button/button.vue'

export default {
  name: 'nt-form-submit',
  components: { CButton },
  props: {
    text: {
      type: String,
      default: 'Submit'
    },
  },
  methods: {
    onSubmit() {
      emitter.emit('formSubmit')
    }
  },
}
</script>

<style lang="scss" scoped>
  .button {
    &--small {
      width: auto;
      font-size: 0.75rem
    }
  }
</style>
